import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {


  public showCancel: boolean = false;
  public title: string = '';
  public message: string = '';
  public acceptButtonText: string = "Accept";
  public cancelButtonText: string = "Cancel";
  public listMessage: string[];

  constructor(private modal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  public get listMessageHtml(): string {
    let html = `<ul style="${this.listCss()}">`;
    this.listMessage.forEach(i => html += `<li>${i}</li>`);
    html += "</ul>";
    return html;
  }

  public listCss() {
    return 'margin-top: 10px;' +
      'font-weight: 500;' +
      'max-height: 10rem;' +
      'font-size: 12px;' +
      'overflow-y: auto;';
      //'border: solid 1px rgba(0,0,0,0.2);' +
      //'border-radius: 0.4rem';
  }

  public close(result: boolean) {
    this.modal.close(result);
  }

}
